<template>
  <market>
    <loader v-if="loading"></loader>

    <section v-if="!loading">
      <div class="row">
        <div class="col-md-12">
          <div class="row">
            <div class="col-lg-5">
              <div class="card h-100">
                <div class="card-body d-flex align-items-center justify-content-center">
                  <b-carousel
                    v-if="feature.attachments"
                    id="carousel1"
                    v-model="slide1"
                    controls
                    indicators
                    background="#ababab"
                    :interval="4000"
                  >
                    <b-carousel-slide
                      v-for="image in feature.attachments"
                      :key="`featureimage-${image.id}`"
                    >
                      <img slot="img" :src="image.url" alt="slide image" />
                    </b-carousel-slide>
                  </b-carousel>
                </div>
              </div>
            </div>
            <div class="col-lg-7">
              <div class="card h-100">
                <div class="card-body">
                  <div class="page-header mb-0">
                    <div class="page-title">{{ feature.name }}</div>
                    <div>
                      <feature-badge :status="feature.status" />
                    </div>
                  </div>
                  <div class="row text-muted p-0 pl-4">{{ feature.comm }}</div>
                  <div class="row">
                    <div class="col-lg-12 pb-0 pt-0">
                      <div class="row">
                        <div class="d-flex w-100 justify-content-between">
                          <b-row class="p-0 pl-3 col-md-3">
                            <b-col class="d-flex align-items-center text-muted text-price">
                              {{ feature.price }} &euro;
                            </b-col>
                            <b-col class="d-flex align-items-center text-muted">
                              <s v-if="feature.oldPrice !== 0" class="text-sale">
                                {{ feature.oldPrice }} &euro;
                              </s>
                            </b-col>
                          </b-row>
                          <b-button
                            disabled
                            variant="outline-success"
                            class="m-3"
                            style="height: 35px"
                          >
                            Buy
                          </b-button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row pl-3 card-separator">{{ $t('box.description') }}</div>
                  <div class="col-12 pl-2 text-muted mt-2" v-html="feature.details"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </market>
</template>

<script>
import featureQuery from '@/api/features/feature.gql';

export default {
  name: 'SmartOeeMarketFeatureDetails',
  data() {
    return {
      slide1: 0,
    };
  },
  computed: {
    loading() {
      return this.$apollo.queries.feature.loading;
    },
  },
  apollo: {
    feature: {
      query() {
        return featureQuery;
      },
      variables() {
        return {
          id: Number(this.$route.params.featureId),
        };
      },
      update(data) {
        const queryData = data[Object.keys(data)[0]];
        if (queryData && queryData.features && queryData.features.length) {
          return queryData.features[0];
        } else {
          this.$store.commit('SET_ERROR', this.$t('box.noExtension'));
          return {};
        }
      },
      error(e) {
        this.$store.commit('SET_ERROR', e.message);
      },
    },
  },
};
</script>

<style lang="scss">
.card-separator {
  height: 40px;
  border-bottom: 3px solid black;
}
</style>
